import { Wording } from '@/types';

export const ASTROLOGY_WORDING_RO: Wording = {
  components_header_media_content: 'Audio',
  components_header_media_1: 'Meditații',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Ghiduri',
  components_header_text2: 'Blog',
  components_header_members: 'Membrii',
  hero_text: 'Explorează stelele din interior',
  hero_button_text: 'Începeți de aici',
  components_ressources_section_title: 'RESURSE',
  components_ressources_subheader_text: 'Toate instrumentele de care aveți nevoie pentru înțelegerea cosmică și descoperirea de sine',
  components_ressources_span_text: 'Extindeți-vă universul interior cu un amestec curat de podcasturi și articole. Indiferent dacă căutați o perspectivă cosmică, claritate sau aliniere spirituală, resursele noastre vă ajută să vă conectați cu astrologia în moduri practice și semnificative.',
  components_ressources_card_1_title: 'Scufundări adânci',
  components_ressources_card_1_text: 'Pătrundeți-vă într-o colecție bogată de podcasturi aprofundate care acoperă astrologie, tarot, arhetipuri cosmice și creștere spirituală, concepute pentru a vă extinde conștientizarea și pentru a vă aprofunda practica.',
  components_ressources_card_2_title: 'Vederi de stele',
  components_ressources_card_2_text: 'Sfaturi astrologice și postări pe blog pentru conștientizarea de sine și creșterea sufletească.',
  components_ressources_link: 'Explorează mai departe',
  components_notes_and_google_title_1: 'Îndrumarea astrologică',
  components_notes_and_google_title_2: 'Rutina cosmică',
  components_notes_and_google_title_3: 'Reflecții',
  components_review_google_text: 'Recenzii',
  media_content_section_title: 'AUDIO',
  media_content_section_subheader_text: 'Podcastul nostru',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Mai multe episoade',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Articole și informații',
  text2_section_button_more: 'Încărcați mai multe',
  components_text1_section_title: 'GHIDURI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Vezi toate ghidurile',
  components_footer_text: 'Trezește-ți Cosmosul Interior: Calea Ta, Stelele Tale.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Număr de înregistrare',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Termeni și condiții',
  components_footer_privacy: 'Politica de confidențialitate',
  button_load_more: 'Încărcați mai multe',
  page_media_1_content_hero_text: 'Episoade podcast',
  page_media_content_menu_foundations: 'Fundamente',
  page_media_content_menu_spirituality: 'Spiritualitate',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psihologie',
  page_media_content_menu_trends: 'Tendințe',
  page_media_2_content_hero_text: 'Media 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Blogul nostru',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Articole și informații',
  enter_email_title: 'Vă rugăm să introduceți adresa dvs. de e-mail pentru a continua',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Intră',
  components_login_success_text: 'Conectare reușită!',
  components_card_link_media_content: 'Ascultă acum',
  components_card_link_text1_content: 'Vizualizați Ghidul',
  components_card_link_text2_content: 'Vezi articolul',
  france: 'Franţa',
  cyprus: 'Cipru',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditaţie',
  page_media_content_menu_all: 'Toate',
};